import jwt_decode from "jwt-decode";

import { userOnPath } from "../shared/pageUtils.js";

import * as Constants from "../../config/constants/Constants.js";

/**
 * Decode the JWT and save some necessary fields from the JWT claims to localstorage for easy access.
 */
export const updateJWT = (props, jwt) => {
    if (jwt !== "") {
        try {
            let decodedToken = decodeJWT(jwt);

            props.user.setUserJWT(jwt);
            props.user.setUsername(decodedToken.username);

            props.roles.setIsAdmin(decodedToken.role === Constants.ROLE_ADMIN);
        } catch (e) {
            console.error(e);
        }
    }
};

/**
 * Decode the JWT to standard JSON format.
 */
export const decodeJWT = (jwt) => {
    try {
        return jwt_decode(jwt);
    } catch (e) {
        console.error(e);
    }
};

/**
 * Deletes local storage variables and refreshes the page.
 *
 * If refreshPage is true, also refresh the whole page.
 * If the path parameter is set, open that page.
 *
 * NB! If a page refresh doesn't happen, any old useState variables might casuse problems and privacy concerns.
 */
export const logUserOut = (props, refreshPage = true, path = "/logout") => {
    if (props.user.username === "" && !userOnPath(["/home", "/about", "/signin", "/signup", "/logout"])) {
        props.browser.navigate("/signup");
    }

    if (props.user.userJWT !== "") {
        props.user.setMe({});
        props.user.setUserJWT("");
        props.user.setIsLoggedIn(false);

        props.browser.navigate(path); // Navigate to a page which doesn't use any JWT variables (no unexpected errors).

        if (refreshPage) {
            window.location.reload();
        }
    }
};
